<template>
    <div class="navbar-tool dropdown ms-3">
        <a class="navbar-tool-icon-box bg-secondary" v-bind:href="urlCart">
            <span class="navbar-tool-label">{{ Object.keys(localCartCollection).length }}</span>
            <i v-bind:class="{ 'ci-cart': !loading, 'ci-loading': loading }" class="navbar-tool-icon"></i>
        </a>
        <div v-if="localCart.subtotalFloat > 0.0" class="navbar-tool-text">
            <small>{{ translate('myCart') }}</small>{{ localCart.subtotal }} ron
        </div>
        <div v-else class="navbar-tool-text">
            <small>{{ translate('myCart') }}</small>0,00 ron
        </div>
        <div class="dropdown-menu dropdown-menu-end">
            <div class="widget widget-cart px-3 pt-2 pb-3" style="width: 20rem;">
                <div v-if="Object.keys(localCartCollection).length">
                    <div style="height: 15rem;" data-simplebar data-simplebar-auto-hide="false">
                        <div v-for="cartItemKey in Object.keys(localCartCollection)" class="widget-cart-item pb-2 border-bottom">
                            <button v-if="!loading" @click="remove(cartItemKey)" class="btn-close text-danger" type="button" aria-label="Remove"><span aria-hidden="true">×</span></button>
                            <div class="d-flex align-items-center">
                                <a class="flex-shrink-0" v-bind:href="localCartCollection[cartItemKey].url">
                                    <img :src="localCartCollection[cartItemKey].image" width="64" :alt="localCartCollection[cartItemKey].name">
                                </a>
                                <div class="ps-2">
                                    <h6 class="widget-product-title"><a v-bind:href="localCartCollection[cartItemKey].url">{{ localCartCollection[cartItemKey].name }}</a></h6>
                                    <div class="widget-product-meta"><span class="text-accent me-2">{{ localCartCollection[cartItemKey].price }} <small>RON</small></span><span class="text-muted">x {{ localCartCollection[cartItemKey].qty }}</span></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="d-flex flex-wrap justify-content-between align-items-center py-3">
                        <div class="fs-sm me-2 py-2">
                            <span class="text-muted">{{ translate('subTotal') }}</span>
                            <span v-if="localCart.subtotalFloat > 0.0" class="text-accent fs-base ms-1">{{ localCart.subtotal }} <small>RON</small></span>
                            <span v-else class="text-accent fs-base ms-1">- <small>RON</small></span>
                        </div>
                        <a class="btn btn-outline-secondary btn-sm" v-bind:href="urlCart">{{ translate('seeCart') }}<i class="ci-arrow-right ms-1 me-n1"></i></a>
                    </div>
                    <a class="btn btn-primary btn-sm d-block w-100" v-bind:href="urlCheckout">
                        <i class="ci-card me-2 fs-base align-middle"></i>{{ translate('finishShopping') }}
                    </a>
                </div>
                <div v-else class="text-center">
                    <h5 class="fw-normal">{{ translate('emptyCart') }}</h5>
                    <a class="btn btn-outline-primary btn-sm ps-2" v-bind:href="urlShop">
                        {{ translate('seeCatalog') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    props: {
        lang: String,
        urlCart: String,
        urlShop: String,
        urlCheckout: String,
        cart: Object,
        cartCollection: Object|Array,
    },
    data () {
        return {
            localCartCollection: this.cartCollection,
            localCart: this.cart,
            loading: false,
            translations: {
                en: {
                    subTotal: 'Subtotal:',
                    myCart: 'My cart',
                    seeCart: 'See cart',
                    emptyCart: 'Empty cart',
                    seeCatalog: 'See catalog of products',
                    finishShopping: 'Finish shopping'
                },
                ro: {
                    subTotal: 'Subtotal:',
                    myCart: 'Cosul meu',
                    seeCart: 'Vezi cos',
                    emptyCart: 'Cosul tau este gol',
                    seeCatalog: 'Vezi catalogul de produse',
                    finishShopping: 'Finalizează cumpărăturile',
                }
            }
        }
    },
    created (){
        window.EventBus.$on('refreshCart', this.refresh)
    },
    methods: {
        translate (key) {
            return this.translations[this.lang][key] || `${this.lang}.${key}`
        },
        remove (cartItemKey) {
            if (!this.loading) {
                this.loading = true
                axios.post('/api/cart/remove', {
                    'id': cartItemKey
                })
                    .then(response => {
                        delete this.localCartCollection[cartItemKey]
                        this.localCart = response.data;
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                    })
            }
        },
        refresh () {
            if (!this.loading) {
                this.loading = true
                axios.post('/api/cart/refresh', {})
                    .then(response => {
                        this.localCart = response.data.cart;
                        this.localCartCollection = response.data.cartCollection;
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false
                    })
            }
        },
    }
}
</script>
